export const trackingIdReadyResolver = {};
export const trackingIdReady = new Promise(
  // eslint-disable-next-line no-return-assign
  resolve => (trackingIdReadyResolver.resolve = resolve),
);
